export const COLORS = {
	close: '#8c8c8c',
	heading: '#444444',
	text: '#444444',
	subHeading: '#8d99a3',
	hyperLink: '#018dd3',
	white: '#ffffff',
	black: '#000000',
	red: '#ef3c3f',
	blue: '#018dd3',
	darkBlue: '#242e3f',
	green: '#47B549',
	lightGreen: '#bdf9bd',
	darkGray: '#404447',
	lightGray: '#8d99a3',
	lightGray2: '#eae9ef',
	lightGray3: '#cfcfcf',
	lightGrayBackground: '#f7f8fa',
	dashboardGreen: '#19bb4b',
	dashboardBlue: '#62a7ff',
	dashboardDarkOrange: '#8e4b01',
	dashboardLightOrange: '#f7a34d',
	gray: '#888888',
	lightGray4: '#595959',
	lightGray5: '#808e98',
	lightGray6: '#818e98',
	lightGray7: '#b1b1b1',
	lightGray8: '#E0E0E0',
	gray2: '#838e97',
	gray3: '#475569',
	grayMenu: '#727d91',
	darkBlue2: '#00295d',
	inputActiveBackground: '#8f8f8f',
	inputActiveColor: '#ffffff',
	inputDisableBackground: '#d1d1d1',
	inputDisableColor: '#999999',
	commonGreen: '#1ef202',
	rareBlue: '#0560b6',
	epicPurple: '#732fc2',
	purple: '#7942e7',
	placeholderGray: '#BFBFBF',
	osloGray: '#595959',
	transparent: '#00000000',
	lochmara: '#0686d0',
	// Accessible secondary/body text colors (WCAG AA, >=4.5:1 on light backgrounds).
	// Use these instead of light grays for readable body text. See ERIN-7684.
	textSecondary: '#475569',
	textSecondaryNeutral: '#595959',
};
